import React from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type EmptyListPropsType = {
    children?: React.ReactNode;
    title: string;
    customClass?: string;
    titleWidth?: number;
    imageSrc?: string;
    altText?: string;
};

const EmptyList: React.FC<EmptyListPropsType> = ({ children, title, customClass, titleWidth, imageSrc, altText }) => {
    const { t } = useTranslation();

    return (
        <>
            <Row className="w-100 justify-content-md-center">
                {imageSrc && (
                    <div className="text-center" style={{ paddingTop: "75px" }}>
                        <img src={imageSrc} alt={altText ? t(altText) : null} className="img-fluid" />
                    </div>
                )}
                <Col md={titleWidth ? titleWidth : 7} xl={5} className={`mt-5 ${customClass}`}>
                    <h5 className="text-center font-weight-bold">{t(title)}</h5>
                </Col>
            </Row>
            <Row className="w-100 justify-content-md-center mt-4">
                <Col md={6} lg={5} xl={3} className="d-flex justify-content-center">
                    {children}
                </Col>
            </Row>
        </>
    );
};

export default EmptyList;
